// swiper-init.js
// This script initializes all Swiper carousels found with the class 'testimonial-swiper'.

// Wait for the DOM to be fully loaded before trying to initialize Swiper
document.addEventListener('DOMContentLoaded', function() {
    // Check if Swiper global object is available (means Swiper library is loaded)
    if (typeof Swiper !== 'undefined') {
        const testimonialSwipers = document.querySelectorAll('.testimonial-swiper'); // Corrected typo here

        testimonialSwipers.forEach(function(swiperElement) { // And corrected here
            // Only initialize if the element hasn't been initialized already (prevents double init)
            if (!swiperElement.swiper) {
                new Swiper(swiperElement, {
                    loop: true, // Enable infinite loop
                    slidesPerView: 1,
                    spaceBetween: 30,
                    centeredSlides: true, // Centers the active slide
                    autoplay: {
                        delay: 5000, // 5 seconds
                        disableOnInteraction: false, // Autoplay continues even after user interaction
                    },
                    navigation: {
                        nextEl: swiperElement.querySelector('.swiper-button-next'),
                        prevEl: swiperElement.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: swiperElement.querySelector('.swiper-pagination'),
                        clickable: true, // Make pagination dots clickable
                    },
                    breakpoints: {
                        // when window width is >= 768px (Tablet)
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        // when window width is >= 992px (Desktop)
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        }
                    }
                });
            }
        });
    } else {
        console.warn('Swiper library not found. Testimonial carousel will not initialize.');
    }
});